import { Navigate } from "react-router-dom";
import { useCurrentUser } from "@/lib/auth";
import EmptyState from "@/components/EmptyState";
import { firstAllowedPath } from "@/lib/pages";

// Гард dev-страниц: только аккаунт разработчика (DEVELOPER_EMAILS на
// сервере). Админы без этого флага страницу не видят — в меню её тоже нет.
export default function DevGuard({ children }: { children: React.ReactNode }) {
  const { user } = useCurrentUser();
  if (!user) return null;
  if (user.isDeveloper) return <>{children}</>;
  const first = firstAllowedPath(user);
  if (first) return <Navigate to={first} replace />;
  return <EmptyState title="Нет доступа к этой странице" />;
}
